import { API_BASE } from '../config';
import { User } from '../types';
import { fetchJson } from './client';

const withAuth = (token: string) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const listUsers = async (limit: number, offset: number, token: string): Promise<User[]> => {
  return fetchJson<User[]>(`${API_BASE}/users?limit=${limit}&offset=${offset}`, withAuth(token));
};

export const getUser = async (id: string, token: string): Promise<User> => {
  return fetchJson<User>(`${API_BASE}/users/${id}`, withAuth(token));
};

export const updateUser = async (
  id: string,
  updates: { first_name: string; last_name: string },
  token: string,
): Promise<User> => {
  return fetchJson<User>(`${API_BASE}/users/${id}`, {
    method: 'PUT',
    ...withAuth(token),
    body: JSON.stringify(updates),
  });
};

export const deleteUser = async (id: string, token: string): Promise<void> => {
  await fetchJson(`${API_BASE}/users/${id}`, {
    method: 'DELETE',
    ...withAuth(token),
  });
};

export const registerUser = async (payload: {
  email: string;
  first_name: string;
  last_name: string;
  password: string;
}): Promise<User> => {
  return fetchJson<User>(`${API_BASE}/users/register`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const loginUser = async (payload: {
  email: string;
  password: string;
}): Promise<{ user: User; token: string }> => {
  return fetchJson<{ user: User; token: string }>(`${API_BASE}/users/login`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
};

export const getCurrentUser = async (token: string): Promise<User> => {
  return fetchJson<User>(`${API_BASE}/users/me`, withAuth(token));
};

export const resendVerificationEmail = async (email: string): Promise<{ message?: string }> => {
  return fetchJson<{ message?: string }>(`${API_BASE}/users/resend-verification`, {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
};
